import { Link } from "react-router-dom";

interface Props {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeading({ title, subtitle, moreLink, moreText = "查看全部" }: Props) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div>
        <h2 className="text-lg md:text-xl font-bold text-foreground-950 font-heading flex items-center gap-2">
          <span className="w-1 h-5 rounded-full bg-accent-500" />
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="shrink-0 inline-flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreText}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}